import React from 'react';
import { Box, Card, CardContent, Divider, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import Helper from '../../../utility/helper';

const useStyles = makeStyles(() => ({
    cardContent: {
        padding: 0,
        '&:last-child': {
            paddingBottom: 0,
        },
    },
}));

const DraftTransportationAccordianCard = (props) => {
    const classess = useStyles();
    const { classes, item } = props;
    const TransportationInfo = item.actualData;
    const InfoBox = ({ label, value }) => (
        <Box
            sx={{
                flexBasis: 'calc(20% - 16px)',
                flexGrow: 0,
                flexShrink: 0,
                minWidth: '180px',
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                }}
            >
                <Typography
                    variant="h4"
                    fontSize={12}
                    fontWeight={500}
                    color="primary"
                >
                    {label}
                </Typography>
                <Typography
                    variant="h4"
                    fontSize={14}
                    fontWeight={400}
                    sx={{ wordWrap: 'break-word' }}
                >
                    {value}
                </Typography>
            </Box>
        </Box>
    );
    return (
        <>
            <Divider sx={{ mb: 1 }} />

            <Card sx={{ boxShadow: 'none', padding: '8px 16px 16px' }}>
                <CardContent className={classess.cardContent}>
                    <Box sx={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        rowGap: 2,
                        columnGap: 2,
                    }}>

                        {!TransportationInfo.isGroundTransport && (<>
                            {TransportationInfo.totalPassengers !== null && (
                                <InfoBox label="No Of People Travelling" value={TransportationInfo.totalPassengers} />
                            )}
                            {(TransportationInfo.passengerDob !== null || TransportationInfo.passangerDOB !== '') ? (
                                <InfoBox label="DOB" value={TransportationInfo.passengerDob || TransportationInfo.passangerDOB} />
                            ) : null}
                            {(TransportationInfo.passengerName || TransportationInfo.passangerName) ? (
                                <InfoBox label="Passenger Name" value={TransportationInfo.passengerName || TransportationInfo.passangerName} />
                            ) : null}
                            {(TransportationInfo.passengerEmail || TransportationInfo.passangerEmail) ? (
                                <InfoBox label="Passenger Email" value={TransportationInfo.passengerEmail || TransportationInfo.passangerEmail} />
                            ) : null}
                            {(TransportationInfo.passengerContactNo || TransportationInfo.passangerContact) ? (
                                <InfoBox label="Passenger contact No" value={TransportationInfo.passengerContactNo || TransportationInfo.passangerContact} />
                            ) : null}
                            {TransportationInfo.tripInfoType === "departure" ?
                                <InfoBox label={"Date/Time"} value={Helper.FormatDateTime(TransportationInfo.fromDate)} />
                                : null}
                            {TransportationInfo.tripInfoType === "arrival" ?
                                <InfoBox label={"Date/Time"} value={Helper.FormatDateTime(TransportationInfo.toDate)} />
                                : null}
                            {TransportationInfo.passangerContact ? (
                                <InfoBox label={'Contact'} value={TransportationInfo.passangerContact} />
                            ) : null}
                            {TransportationInfo.gender &&
                                (
                                    <InfoBox label={'Gender'} value={TransportationInfo.gender} />
                                )}
                            {TransportationInfo.fromLocation &&
                                (
                                    <InfoBox label={'Departure Airport'} value={TransportationInfo.fromLocation} />
                                )
                            }
                            {TransportationInfo.toLocation &&
                                (
                                    <InfoBox label={'Arrival Airport'} value={TransportationInfo.toLocation} />
                                )}
                            {TransportationInfo.airline != '' ? (
                                <InfoBox label={'Preferred Airline'} value={TransportationInfo.airline} />
                            ) : null}
                            {TransportationInfo.flightNo != '' ? (
                                <InfoBox label={TransportationInfo.isPrivate ? "Tail No" : "Frequent Flyer"} value={TransportationInfo.flightNo} />
                            ) : null}
                            {TransportationInfo.comments ? (
                                <InfoBox label={'Comments'} value={TransportationInfo.comments} />
                            ) : null}
                            {TransportationInfo.tsa ? (
                                <InfoBox label={'TSA'} value={TransportationInfo.tsa} />
                            ) : null}
                            {TransportationInfo.ticketType ? (
                                <InfoBox label={'Ticket Type'} value={TransportationInfo.ticketType && TransportationInfo.ticketType === 1 ? 'Business' : 'Economy'} />
                            ) : null}
                            {(TransportationInfo.lastModifiedDate !== "0001-01-01T00:00:00"
                                && TransportationInfo.lastModifiedDate !== null) && !props.enduser ? (
                                <InfoBox label={'Modified Date'} value={Helper.FormatDateTime(TransportationInfo.lastModifiedDate)} />
                            ) : null}
                        </>)}
                        {!props.enduser && TransportationInfo.isGroundTransport && (<>
                            <InfoBox label={'Ground transportation needed'} value={TransportationInfo.isGroundTransport ? "Yes" : 'No'} />
                            <InfoBox label={'Pickup Address'} value={TransportationInfo.groundPickupAddress} />
                            <InfoBox label={'Drop-off Address'} value={TransportationInfo.groundDropoffAddress} />
                        </>)}
                    </Box>
                </CardContent>
            </Card>
        </>
    );
}; 
export default DraftTransportationAccordianCard; 